import React from "react";
import { Info } from "lucide-react";
import { cn } from "@/lib/utils";

const InfoMessage = React.forwardRef(
  ({ message, children, title, className, ...props }, ref) => {
    const content = children ?? message;

    if (!content) {
      return null;
    }

    return (
      <div ref={ref} className={cn("mb-4 space-y-3", className)} {...props}>
        {title ? (
          <p className="pl-3 text-xs font-medium uppercase text-gray-0">{title}</p>
        ) : null}
        <div
          role="status"
          className="flex items-center gap-3 rounded-lg bg-sky-400/10 p-2.5"
        >
          <div className="relative flex h-4 w-4 shrink-0 items-center justify-center">
            <span
              className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400/50 motion-reduce:animate-none"
              aria-hidden="true"
            />
            <div className="relative flex h-6 w-6 items-center justify-center">
              <Info className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" />
            </div>
          </div>
          <p className="min-w-0 flex-1 text-sm leading-relaxed text-sky-400/70 sm:text-base font-sans">
            {content}
          </p>
        </div>
      </div>
    );
  },
);

InfoMessage.displayName = "InfoMessage";

export { InfoMessage };
